import type { SanityPageBuilderExternalProductsCard, SanityPageBuilderExternalProductsSection, SanityPageBuilderSection } from "@ouster/shared";
import { ExternalProductsBlockView } from "~/features/blocks/inventory/external-products";
import { ExternalProductCardView, type ExternalProductCardViewProps } from "~/features/blocks/inventory/external-products/external-product-card";
import { toHtml } from "~/features/sanity/rich-text/to-html";
import { toCraftMedia } from "../../media";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderExternalProductsSection;
  };
};
type ExternalProductsViewCard = ExternalProductCardViewProps & Pick<SanityPageBuilderExternalProductsCard, "_key">;
export function SanityExternalProductsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const cards = sectionContent.cards?.flatMap<ExternalProductsViewCard>(card => {
    const media = toCraftMedia(card.media);
    if (!media) {
      return [];
    }
    return [{
      _key: card._key,
      description: toHtml(card.description),
      media: [media],
      title: card.title,
      url: card.url
    }];
  }) ?? [];
  return <ExternalProductsBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} cards={cards} eyebrow={sectionContent.eyebrow} getCardKey={(card, index) => card._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} mode={sectionSettings?.mode || "light"} renderCard={card => <ExternalProductCardView {...card} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}